<rt-dialog-body variant="no-padding" class="report-dialog-body">
  <header class="header-area">
    <ng-content select="[header]" />
  </header>

  <div class="content">
    <section class="sidebar-area" [class.has-scroll-y]="scrollableSidebar()">
      <ng-content select="[sidebar]" />
    </section>

    <section class="main-container-area">
      <section
        #topArea
        class="top-area"
        [class.empty]="!(topAreaRef()!.nativeElement.children.length > 0)"
      >
        <ng-content select="[top]" />
      </section>

      <div class="main-area" #scrollContainer>
        <ng-content select="[main]" />
      </div>
    </section>
  </div>
</rt-dialog-body>
